/*
 * 戒导航 · 提及模块（jiedh/mention）前台初始化
 * =============================================================================
 * 职责（详见 packages/mention/extend.php 头部注释、doc/输入框富文本编辑器设计方案.md §8）：
 *   让富文本编辑器（fof/rich-text 的 Tiptap 驱动）认得出 flarum/mentions 的四种提及语法 ——
 *     ① 帖子提及  @"显示名"#p帖子ID   （回复按钮插入的那一种，即用户反馈的「乱码」）
 *     ② 用户提及  @"显示名"#用户ID
 *     ③ 用户提及  @用户名            （旧式写法，由后台设置 allow_username_format 决定）
 *     ④ 群组提及  @"组名"#g群组ID
 *     ⑤ 标签提及  #标签slug
 *   编辑器内直接把它们渲染成提及小标签（不再是源码原文）；
 *   提交时再**原样**序列化回提及源码，落库格式与改造前逐字节一致。
 *
 * 注意：initializers.add() 的 name 必须与扩展 ID 对应（本包 ID 为 jiedh/mention）。
 * 注册动作本身与执行顺序无关：三腿都走字符串目标的 extend()，
 * 由 flarum.reg.onLoad 延迟解析 —— fof/rich-text 的模块无论何时加载都能接上。
 */
import app from 'flarum/forum/app';
import { registerMentions } from './registerMentions';
app.initializers.add('jiedh-mention', () => {
  registerMentions();
});